import React, { useState, useEffect } from "react";
import SearchBar from "./SearchBar";
import VideoList from "./VideoList";
import VideoDetail from "./VideoDetail";
import useVideos from "../hooks/useVideos";
import ReactTypingEffect from "react-typing-effect";

const YoutubeMain = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videos, search] = useVideos("banana");

  useEffect(() => {
    document.body.style.backgroundColor = "rgb(93, 45, 0)";
  });

  useEffect(() => {
    setSelectedVideo(videos[0]);
  }, [videos]);

  return (
    <div className="container youtube__container">
      <h1 className="todolist-header">
        <ReactTypingEffect
          text={["Youtube Search Proxy App", "Enter a term"]}
        />
      </h1>
      <SearchBar onTermSubmit={search} />
      Returned {videos.length} videos.
      <div className="youtube__child__container">
        <div className="youtube__videos">
          <div className="youtube__main__video__container">
            <VideoDetail video={selectedVideo} />
          </div>
          <div className="youtube__right__grid">
            <VideoList
              videos={videos}
              //! SUPER IMPORTANT: IN HERE:
              //* (video) => setSelectedVideo(video)
              //! IS SAME AS
              //*  setSelectedVideo
              //! CUZ SENT PARAMS ARE THE SAME AS ONES PASSED.
              onVideoSelect={setSelectedVideo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default YoutubeMain;
